import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setError(apiError(err.response?.data?.detail) || "Something went wrong"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="h-9 w-9 rounded-md bg-primary flex items-center justify-center"><Building2 className="h-5 w-5 text-primary-foreground" /></div>
          <div className="leading-tight">
            <p className="font-display font-black tracking-tight text-xl">Bid Router</p>
            <p className="text-[10px] uppercase tracking-widest text-muted-foreground -mt-0.5">by Conduit Systems</p>
          </div>
        </div>
        {sent ? (
          <div data-testid="forgot-sent">
            <div className="h-10 w-10 rounded-md bg-emerald-100 flex items-center justify-center mb-4"><MailCheck className="h-6 w-6 text-emerald-600" /></div>
            <h1 className="font-display font-black text-2xl tracking-tight">Check your email</h1>
            <p className="text-sm text-muted-foreground mt-2">If an account exists for <span className="font-medium text-foreground">{email}</span>, a password reset link is on its way. It expires in 1 hour.</p>
            <Link to="/login" className="inline-flex items-center gap-1 text-primary font-medium text-sm mt-6" data-testid="back-to-login"><ArrowLeft className="h-4 w-4" />Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="font-display font-black text-3xl tracking-tight">Forgot password</h1>
            <p className="text-muted-foreground text-sm mt-1 mb-6">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-xs uppercase tracking-widest">Email</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" className="mt-1.5" placeholder="you@company.com" />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">{loading ? "Sending…" : "Send reset link"}</Button>
            </form>
            <Link to="/login" className="inline-flex items-center gap-1 text-muted-foreground hover:text-foreground text-sm mt-6" data-testid="back-to-login"><ArrowLeft className="h-4 w-4" />Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
